import React, { useEffect, useState } from 'react';

import { AuthRoutes } from '../../../interfaces/routes';
import { withStyles } from '@material-ui/core/styles';
import {
  createFiltersQuery,
  getAppliedFilters,
  SelectedFilters,
} from '../../filtersDrawer/FiltersDrawer';
import StackedStats, {
  CardContainerVariants,
  CardItemVariants,
  StatData,
} from '../../stackedStats/StackedStats';
import { LoaderRing } from '../../primitives';
import { CARD_LOAD_DELAY } from '../Dashboard';
import queryString from 'query-string';
import useMountedStatus from '../../../hooks/useMountedStatus';
import { setErrorByPS } from './utils/utils';

//Services
import EphemeralStateService from '../../../services/EphemeralState.service';
import OutboundLoadsService from '../../../services/OutboundLoads.service';

interface Props {
  title: string;
  index: number;
  filters?: SelectedFilters;
  classes: { [key: string]: string };
}

const LoadsStats: React.FC<Props> = ({
  title,
  index,
  filters,
  classes,
}) => {
  const [data, setData] = useState<StatData>({});
  const [percentDispatched, setPercentDispatched] =
    useState<number>();

  const componentMounted = useMountedStatus();

  const fetchStats = async () => {
    const statesConfig =
      EphemeralStateService.getMyStationConfiguratation()?.GENERAL
        ?.STATES || null;

    const loadLables: { key: any; label: any }[] = [
      {
        key: 'LOADING',
        label: statesConfig['LOAD_LOADING'].label,
      },
      {
        key: 'DISPATCHED',
        label: statesConfig['LOAD_DISPATCHED'].label,
      },
    ];

    let results: StatData = loadLables.reduce((acc, step) => {
      return {
        ...acc,
        [step.key]: {
          label: step.label,
          value: 'pending',
        },
      };
    }, {});

    setData(results);

    let totalItems = 0;
    let numberOfStatsFetched = 0;

    const filtersQuery = createFiltersQuery(filters);

    setTimeout(() => {
      loadLables.forEach((ps, index) => {
        OutboundLoadsService.getAll({
          pageSize: 1,
          outboundLoadStatus: ps.key,
          owner:
            filters && filters.owner && filters.owner.values.length
              ? filters.owner.values.map((item: any) => item.id)
              : undefined,
          carrier:
            filters &&
            filters.carrier &&
            filters.carrier.values.length
              ? filters.carrier.values.map((item: any) => item.id)
              : undefined,
          route:
            filters && filters.route && filters.route.values.length
              ? filters.route.values.map((item: any) => item.id)
              : undefined,
          stop:
            filters && filters.stop && filters.stop.values.length
              ? filters.stop.values.map((item: any) => item.id)
              : undefined,
          hidePending:
            filters &&
            filters.hidePending &&
            filters.hidePending.values.length
              ? filters.hidePending.values[0].id === 'yes'
                ? true
                : filters.hidePending.values[0].id === 'no'
                ? false
                : undefined
              : undefined,
        })
          .then((res) => {
            results = {
              ...results,
              [ps.key]: {
                ...results[ps.key],
                value: res.data.count,
                filter: {
                  name:
                    queryString.stringify(filtersQuery) +
                    '&loadStatus',
                  value: ps.label,
                },
                itemsStyleVariant:
                  ps.key === 'DISPATCHED'
                    ? CardItemVariants.GOLD_PAPER
                    : undefined,
              },
            };
            if (componentMounted) {
              setData(results);
            }
            totalItems += res.data.count;
            numberOfStatsFetched++;

            if (
              numberOfStatsFetched === loadLables.length &&
              componentMounted
            ) {
              //all calls are finished
              setPercentDispatched(
                totalItems !== 0
                  ? Math.round(
                      (Number(results['DISPATCHED'].value) /
                        totalItems) *
                        100,
                    )
                  : 100,
              );
            }
          })
          .catch((e) => {
            if (componentMounted) {
              setData(
                setErrorByPS(
                  (results = {
                    ...results,
                    [ps.key]: {
                      label: ps.label,
                      value: 'error',
                    },
                  }),
                  ps.key,
                  ps.label,
                ),
              );
            }
          });
      });
    }, index * CARD_LOAD_DELAY);
  };

  useEffect(() => {
    fetchStats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return data ? (
    <>
      <StackedStats
        title={title}
        containerStyleVariant={CardContainerVariants.WHITE}
        itemsStyleVariant={CardItemVariants.WHITE_PAPER}
        dataTestId='loads-stats'
        stats={data}
        linkBase={AuthRoutes.OUTBOUND_LOAD}
        percentage={percentDispatched}
        filters={getAppliedFilters(filters)}
      />
    </>
  ) : (
    <LoaderRing />
  );
};

export default withStyles({})(LoadsStats);
